import { setVerificationServiceConfigurations } from "@redux/actions/verification-services-actions";
import { VerificationServiceChangeRequest } from "@idw-types/data/verification-service";
import { Dispatch } from "redux";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { getVerificationServiceConfigurationsRequest, updateVerificationServiceChangeRequestRequest } from "@requests/service-configuration";
import { formatVerificationServiceConfigurations } from "@formatters/verification-services/verification-service-configuration-formatter";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany, AxnRelyingParty, SimpleAxnWorkflow } from "@idw-types/data/reference-data/axn";
import { RpServiceType } from "@idw-types/data/reference-data/generic";

export const updateVerificationServiceChangeRequestReduxRequest = (dispatch: Dispatch) => async (
    rpServiceId: string,
    body: { [key: string]: any },
    changeRequestStatus: ChangeRequestStatusTypes,
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>,
    rpServiceTypes: Array<RpServiceType>,
    simpleAXNWorkflows: Array<SimpleAxnWorkflow>,
    simpleAXNAdminWorkflows: Array<SimpleAxnWorkflow>
): Promise<VerificationServiceChangeRequest> => {
    const { data, error } = await updateVerificationServiceChangeRequestRequest(rpServiceId, body, changeRequestStatus);
    if (data?.transferObject) {
        if (![ChangeRequestStatusTypes.REJECTED, ChangeRequestStatusTypes.APPROVED].includes(changeRequestStatus)) {
            const verificationServiceConfigurationsResponse = await getVerificationServiceConfigurationsRequest();
            if (verificationServiceConfigurationsResponse.data?.rpserviceConfigs) {
                const formattedVerificationServiceConfigurations = formatVerificationServiceConfigurations(
                    verificationServiceConfigurationsResponse.data.rpserviceConfigs,
                    companies,
                    relyingParties,
                    rpServiceTypes,
                    simpleAXNWorkflows,
                    simpleAXNAdminWorkflows
                );
                dispatch(setVerificationServiceConfigurations(formattedVerificationServiceConfigurations));
                displaySuccessModal(
                    dispatch,
                    resources.requests.updateVerificationServiceChangeRequest.success.title,
                    resources.requests.updateVerificationServiceChangeRequest.success.message
                );
            }
        }
        return data.transferObject;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateVerificationServiceChangeRequest.error.title,
            resources.requests.updateVerificationServiceChangeRequest.error.message,
            error,
            null,
            body
        );
    }
    return null;
};